module.exports = __webpack_public_path__ + "static/media/5.769531d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/5.png
// module id = 1500
// module chunks = 0